import React from 'react';
import numeral from 'numeral';
import { getCurrentUserCompanyId, getCurrentUserSubCompanyId, getCurrentUserId, getRoles } from '../../../services/userRights';
import AutoCompleteTextInput from '../../../controls/autoCompleteTextInput.jsx';
import CheckBoxInput from '../../../controls/checkBoxInput.jsx';
import ConfirmModal from '../../../modals/confirmModal.jsx';
import DateTimeInput from '../../../controls/dateTimeInput.jsx';
import InfoModal from '../../../modals/infoModal.jsx';
import SelectInput from "../../../controls/selectInput.jsx";
import TextInput from '../../../controls/textInput.jsx';
import SelectWarehouseModal from '../../../modals/selectWarehouseModal.jsx';
import FillRecipientCompanyModal from '../../../modals/fillRecipientCompanyModal.jsx';
import { apiGet, apiPost, apiPut } from '../../../services/apiClient';

import PhoneInput from 'react-phone-input-2';
import ru from 'react-phone-input-2/lang/ru.json';
import 'react-phone-input-2/lib/high-res.css';

import moment from 'moment';
import i18n from "../../../services/i18n";
import { Trans } from "react-i18next";
import { findPhoneNumbersInText } from 'libphonenumber-js'

export default class CreateParcelForm2 extends React.Component {


    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            step: 0, //0 - ввод города, 1 - выбор тарифа, 2 - заполнение доп. информации, 3 - перевыбор тарифа, 20 - заказ создан
            companyId: null,
            subCompanyId: null,
            countries: null,
            regions: null,
            cities: null,
            warehouses: null,
            currentLanguage: 'ru',
            isDocument: true,
            documentWeight: 0.1,

            //Блок расширенного заполнения адреса
            shipmentCity: null,
            shipmentCityAddress: null,
            shipmentCityAddressName: null,
            shipmentAddressCountry: null,
            shipmentCityName: null,
            shipmentFullCityName: null,
            shipmentStreet: null,
            shipmentHouse: null,
            shipmentOffice: null,
            shipmentPostalCode: null,
            shipmentAddressName: null,
            shipmentComment: null,
            shipmentContactPersonName: null,
            shipmentPhoneNumber: null,

            deliveryCity: null,
            deliveryCityAddress: null,
            deliveryCityAddressName: null,
            deliveryAddressCountry: null,
            deliveryCityName: null,
            deliveryFullCityName: null,
            deliveryStreet: null,
            deliveryHouse: null,
            deliveryOffice: null,
            deliveryPostalCode: null,
            deliveryAddressName: null,
            deliveryComment: null,
            deliveryContactPersonName: null,
            deliveryPhoneNumber: null,
            defaultCountry: 'ru',

            cargoLength: 10,
            cargoWidth: 10,
            cargoHeight: 10,
            cargoWeight: 1,
            cargoVolume: 0.1,
            cargoPackages: 1,
            departureDate: moment().add(1, 'days').format('YYYY-MM-DD'),
            tariffs: null,
            selectedTariff: null,
            canEditFromAddress: true,
            canEditToAddress: true,
            //Блок Откуда-Куда
            fromAddressCountry: null,
            fromAddressId: null,
            fromAddressName: null,
            originFromCityName: null,

            foAddressCountry: null,
            toAddressId: null,
            toAddressName: null,
            originToCityName: null,

            parcelId: null,
            vehicleTypeId: null,
            carrierPublicOfferUrl: null,
            errors: {}
        };
        i18n.changeLanguage(this.state.currentLanguage);

    }

    componentDidMount() {
        this.reload();
    }

    reload() {
        let companyId = getCurrentUserCompanyId();
        let subCompanyId = getCurrentUserSubCompanyId();
        this.setState((prevState, props) => {
            prevState.companyId = companyId;
            prevState.subCompanyId = subCompanyId;
        });

        this.loadCountries(false);
        this.loadCountries(true);
        this.loadWarehouses(companyId);
    }

    getVehicleType(companyId) {
        this.updateBusyCount(1);
        apiGet('ref/vehicletypes/list/' + companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.vehicleTypes = data.entries.map((entry, ind, array) => {
                        if (entry.name === 'Курьерская доставка (без режима)') {
                            prevState.vehicleTypeId = entry.id;
                            return;
                        }
                    });
                    return;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    loadWarehouses(companyId) {
        this.updateBusyCount(1);
        return apiGet('ref/warehouses/list/' + companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState({
                    warehouses: data.entries
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    loadCountries(isShipmentAddress) {
        this.updateBusyCount(1);
        apiGet("ref/addressies/countries/list?isDefault=false&addressSuggestionType=" + (isShipmentAddress ? 0 : 1))
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.countries = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.code }; });
                    let defaultCountry = data.entries.find(e => e.isDefault);
                    if (defaultCountry !== undefined && defaultCountry !== null) {
                        if (isShipmentAddress) {
                            prevState.fromAddressCountry = { Id: defaultCountry.id, Code: defaultCountry.code };
                            prevState.shipmentAddressCountry = { Id: defaultCountry.id, Code: defaultCountry.code };
                        } else {
                            prevState.toAddressCountry = { Id: defaultCountry.id, Code: defaultCountry.code };
                            prevState.deliveryAddressCountry = { Id: defaultCountry.id, Code: defaultCountry.code };
                        }
                    }

                    return prevState;
                });
            });
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    handleParcelTypeSwitch(isDocument) {
        this.setState({
            isDocument: isDocument,
            tariffs: null
        });
    }

    handleChangeFromCountry(e) {
        this.clearFromWarehouse();
        this.setState({
            tariffs: null,
            shipmentAddressName: null,
            shipmentAddressCountry: null,
            shipmentCity: null,
            shipmentCityName: null,
            shipmentFullCityName: null,
            shipmentPostalCode: null,
            shipmentStreet: null,
            shipmentHouse: null,
            originFromCityName: null,
            fromCityName: null,
            fromRegionName: null,
            fromAddressName: null,
            fromAddress: null,
            fromAddressCountry: {
                Id: e ? e.value : null,
                Code: e ? e.label : null
            }
        });
    }

    handleChangeShipmentCountry(e) {
        this.setState({
            shipmentCity: null,
            shipmentCityName: null,
            shipmentFullCityName: null,
            shipmentPostalCode: null,
            shipmentStreet: null,
            shipmentHouse: null,
            shipmentAddressCountry: {
                Id: e ? e.value : null,
                Code: e ? e.label : null
            }
        });
    }

    handleChangeToCountry(e) {
        this.clearToWarehouse();
        this.setState({
            tariffs: null,
            deliveryAddressCountry: null,
            deliveryCity: null,
            deliveryCityName: null,
            deliveryFullCityName: null,
            deliveryPostalCode: null,
            deliveryStreet: null,
            deliveryHouse: null,
            originToCityName: null,
            toCityName: null,
            toRegionName: null,
            toAddressName: null,
            toAddress: null,
            toAddressCountry: {
                Id: e ? e.value : null,
                Code: e ? e.label : null
            }
        });
    }

    handleChangeDeliveryCountry(e) {
        this.setState({
            deliveryCity: null,
            deliveryCityName: null,
            deliveryFullCityName: null,
            deliveryPostalCode: null,
            deliveryStreet: null,
            deliveryHouse: null,
            deliveryAddressCountry: {
                Id: e ? e.value : null,
                Code: e ? e.label : null
            }
        });
    }

    loadAddressSuggestions(text, sessionKey) {
        return apiPost('parcels/addresses/suggestions',
            {
                text: text,
                sessionKey: sessionKey,
                maxCount: 10,
                source: 0
            })
            .then(data => data.entries);
    }

    loadCitySuggestions(text, sessionKey, countryCode, isShipmentAddress) {
        if (!text) {
            return apiPost('parcels/addresses/citySuggestions',
                {
                    text: text,
                    maxCount: 10,
                    countryCode: countryCode,
                    addressSuggestionType: isShipmentAddress ? 0 : 1,
                    source: 0
                })
                .then(data => data.entries);
        } else {
            return apiPost('parcels/addresses/cityAddressSuggestions',
                {
                    text: text,
                    countryCode: countryCode,
                    sessionKey: sessionKey,
                    maxCount: 10,
                    source: 0
                })
                .then(data => data.entries);
        }
    }

    loadFullCityAddressSuggestions(text, sessionKey, countryCode) {
        return apiPost('parcels/addresses/fullCityAddressSuggestions',
            {
                text: text,
                countryCode: countryCode,
                sessionKey: sessionKey,
                maxCount: 10
            })
            .then(data => data.entries)
    }


    loadStreetAddressSuggestions(text, sessionKey, countryCode, cityName) {
        return apiPost('parcels/addresses/streetAddressSuggestions',
            {
                text: text,
                countryCode: countryCode,
                cityName: cityName,
                sessionKey: sessionKey,
                maxCount: 10,
                source: 0
            })
            .then(data => data.entries);
    }

    loadHouseAddressSuggestions(text, sessionKey, countryCode, cityName, streetName) {
        return apiPost('parcels/addresses/houseAddressSuggestions',
            {
                streetName: streetName,
                cityName: cityName,
                countryCode: countryCode,
                text: text,
                sessionKey: sessionKey,
                maxCount: 10,
                source: 0
            })
            .then(data => data.entries);
    }

    //#region Handle Selects and Inputs
    handleFromAddressSelect(item) {
        this.setState({
            fromRegionName: item.region,
            fromCityName: item.city,
            shipmentPostalCode: item.postalCode,
            shipmentCityName: item.city,
            shipmentFullCityName: item.fullCityAddress,
            shipmentAddressName: item.fullName,
            originFromCityName: item.city,
            tariffs: null
        });

        if (item.id) {
            this.setState({
                shipmentCity: item
            });
        } else {
            this.setState({
                fromAddress: item,
                shipmentCityAddressName: item.cityAddress,
                shipmentStreet: item.street,
                shipmentHouse: item.fullHouseAddress,
            });
        }
    }

    handleFromAddressChange(value) {
        this.setState({
            fromAddress: null,
            fromCityName: null,
            fromRegionName: null,
            shipmentPostalCode: null,
            shipmentCity: null,
            shipmentCityName: null,
            shipmentFullCityName: null,
            shipmentCityAddressName: null,
            shipmentAddressName: value,
            tariffs: null
        });
    }

    handleToAddressSelect(item) {
        this.setState({
            toRegionName: item.region,
            toCityName: item.city,
            deliveryPostalCode: item.postalCode,
            deliveryCityName: item.city,
            deliveryFullCityName: item.fullCityAddress,
            originToCityName: item.city,
            tariffs: null
        });

        if (item.id) {
            this.setState({
                deliveryCity: item,
                deliveryAddressName: item.fullName
            });
        } else {
            this.setState({
                toAddress: item,
                deliveryCityAddressName: item.cityAddress,
                deliveryStreet: item.street,
                deliveryHouse: item.fullHouseAddress,
                deliveryAddressName: item.fullName
            });
        }
    }

    handleToAddressChange(value) {
        this.setState({
            toAddress: null,
            toCityName: null,
            toRegionName: null,
            deliveryPostalCode: null,
            deliveryCity: null,
            deliveryCityName: null,
            deliveryFullCityName: null,
            deliveryCityAddressName: null,
            deliveryAddressName: value,
            tariffs: null
        });
    }

    handleShipmentWarehouseChange(value) {
        this.setState({
            shipmentWarehouse: null,
            shipmentWarehouseName: value,
            canEditFromAddress: true
        });
    }

    handleDeliveryWarehouseChange(value) {
        this.setState({
            deliveryWarehouse: null,
            deliveryWarehouseName: value,
            canEditToAddress: true
        });
    }

    handleDocumentWeight(value) {
        this.setState({
            documentWeight: value,
            tariffs: null
        });
    }

    handleWeight(value) {
        this.setState({
            cargoWeight: value,
            tariffs: null
        });
    }

    handleVolume(value) {
        this.setState({
            cargoVolume: value,
            tariffs: null
        });
    }

    handlePackages(value) {
        this.setState({
            cargoPackages: value,
            tariffs: null
        });
    }

    handleCargoDescription(value) {
        this.setState({
            cargoDescription: value,
            tariffs: null
        });
    }

    handleSelectTariff(collection, index, deliveryDays) {
        let selectedTariff = collection[index];

        if (selectedTariff.isRecipientCompanyRequired
            && (!this.state.recipientCompanyName || this.state.recipientCompanyName.length == 0
            || !this.state.recipientInn || this.state.recipientInn.length == 0)) {
            this.fillRecipientModal.open(this.state.recipientInn, this.state.recipientCompanyName)
                .then(data => {
                    this.setState({
                        recipientInn: data.recipientInn,
                        recipientCompanyName: data.recipientCompanyName
                    }, () => this.handleSelectTariff(collection, index, deliveryDays));
                });
            return;
        }

        this.setState(prevState => ({
            tariffs: prevState.tariffs.map(
                t => (prevState.tariffs.indexOf(t) === index ? Object.assign(t, { isSelected: true }) : t)
            ),
            selectedTariff: selectedTariff,
            carrierPublicOfferUrl: selectedTariff.carrierPublicOfferUrl,
            step: 2
        }));
        this.getVehicleType(this.state.companyId);
    }

    handleShipmentAddressChange(value) {
        this.state.errors && delete this.state.errors.shipmentCity;
        this.setState({
            shipmentPostalCode: null,
            shipmentStreet: null,
            shipmentHouse: null,
            fromAddress: null,
            shipmentCityName: null,
            shipmentFullCityName: value
        });
    }

    handleShipmentStreetChange(value) {
        this.setState({
            shipmentHouse: null,
            shipmentStreet: value
        });
    }

    handleDeliveryStreetChange(value) {
        this.setState({            
            deliveryHouse: null,
            deliveryStreet: value
        });
    }

    handleShipmentHouseChange(value) {
        this.state.errors && delete this.state.errors.shipmentHouse;
        this.setState({            
            shipmentHouse: value
        });
    }

    handleShipmentContactPersonChange(value) {
        this.state.errors && delete this.state.errors.shipmentContactPerson;
        this.setState({
            shipmentContactPersonName: value
        });
    }

    handleDeliveryContactPersonChange(value) {
        this.state.errors && delete this.state.errors.deliveryContactPerson;
        this.setState({
            deliveryContactPersonName: value
        });
    }

    handleShipmentPhoneChange(value) {
        this.state.errors && delete this.state.errors.shipmentPhone;
        this.setState({
            shipmentPhoneNumber: value
        });
    }

    handleDeliveryPhoneChange(value) {
        this.state.errors && delete this.state.errors.deliveryPhone;
        this.setState({
            deliveryPhoneNumber: value
        });
    }

    handleDeliveryHouseChange(value) {
        this.state.errors && delete this.state.errors.deliveryHouse;
        this.setState({            
            deliveryHouse: value
        });
    }

    handleShipmentWarehouseSelect(item) {
        let country = this.state.countries.find(c => c.label === item.address.countryCode);
        this.setState({
            fromAddressCountry: {
                Id: country ? country.value : null,
                Code: country ? country.label : null
            },
            shipmentAddressCountry: {
                Id: country ? country.value : null,
                Code: country ? country.label : null
            },
            shipmentWarehouse: item,
            shipmentWarehouseName: item.name,
            fromRegionName: item.address ? item.address.region : '',
            fromCityName: item.address ? item.address.city : '',
            shipmentPostalCode: item.address ? item.address.postalCode : '',
            shipmentCityName: item.city,
            shipmentFullCityName: item.fullCityAddress,
            shipmentAddressName: item.address ? item.address.fullName : '',
            fromAddress: item.address,
            canEditFromAddress: item.isUserPoint,
            shipmentStreet: item.address ? item.address.street : '',
            shipmentHouse: item.fullHouseAddress,
            shipmentComment: item.pointContactInfo ? item.pointContactInfo.comment : '',
            shipmentContactPersonName: item.pointContactInfo ? item.pointContactInfo.contactName : '',
            shipmentPhoneNumber: item.pointContactInfo ? item.pointContactInfo.contactPhone : '',
            errors: {}
        });
    }

    handleShipmentAddressSelect(item) {
        if (item.postalCode) {
            this.state.errors && delete this.state.errors.shipmentPostalCode;
        }
        this.setState({
            fromAddress: item,
            shipmentFullCityName: item.fullCityAddress,
            shipmentCityName: item.city,
            fromRegionName: item.region,
            fromCityName: item.city,
            shipmentPostalCode: item.postalCode,
        });
    }

    handleShipmentStreetSelect(item) {
        this.setState({
            shipmentStreet: item.street
        });
    }

    handleDeliveryStreetSelect(item) {
        this.setState({
            deliveryStreet: item.street
        });
    }

    handleShipmentHouseSelect(item) {
        this.state.errors && delete this.state.errors.shipmentPostalCode;
        if (!item.postalCode) {
            item.postalCode = this.state.shipmentPostalCode
        };
        this.setState({
            shipmentHouse: item.houseAddress,
            shipmentPostalCode: item.postalCode,
            fromAddress: item,
            fromAddressName: item.fullName
        });
    }

    handleDeliveryHouseSelect(item) {
        this.state.errors && delete this.state.errors.deliveryPostalCode;
        if (!item.postalCode) {
            item.postalCode = this.state.deliveryPostalCode
        };
        this.setState({
            deliveryHouse: item.houseAddress,
            deliveryPostalCode: item.postalCode,
            toAddress: item,
            toAddressName: item.fullName
        });
    }

    handleDeliveryWarehouseSelect(item) {
        let country = this.state.countries.find(c => c.label === item.address.countryCode);
        this.setState({
            toAddressCountry: {
                Id: country ? country.value : null,
                Code: country ? country.label : null
            },
            deliveryAddressComment: {
                Id: country ? country.value : null,
                Code: country ? country.label : null
            },
            deliveryWarehouse: item,
            deliveryWarehouseName: item.name,
            toRegionName: item.address ? item.address.region : '',
            toCityName: item.address ? item.address.city : '',
            deliveryPostalCode: item.address ? item.address.postalCode : '',
            deliveryCityName: item.city,
            deliveryFullCityName: item.fullCityAddress,
            deliveryAddressName: item.address ? item.address.fullName : '',
            toAddress: item.address,
            canEditToAddress: item.isUserPoint,
            deliveryStreet: item.address ? item.address.street : '',
            deliveryHouse: item.fullHouseAddress,
            deliveryComment: item.pointContactInfo ? item.pointContactInfo.comment : '',
            deliveryContactPersonName: item.pointContactInfo ? item.pointContactInfo.contactName : '',
            deliveryPhoneNumber: item.pointContactInfo ? item.pointContactInfo.contactPhone : '',
            errors: {}
        });
    }

    handleDeliveryAddressChange(value) {
        this.state.errors && delete this.state.errors.deliveryCity;
        this.setState({
            deliveryPostalCode: null,
            deliveryStreet: null,
            deliveryHouse: null,
            toAddress: null,
            deliveryCityName: null,
            deliveryFullCityName: value
        });
    }

    handleDeliveryAddressSelect(item) {
        if (item.postalCode) {
            this.state.errors && delete this.state.errors.deliveryPostalCode;
        }
        this.setState({
            toAddress: item,
            deliveryFullCityName: item.fullCityAddress,
            deliveryCityName: item.city,
            toRegionName: item.region,
            toCityName: item.city,
            deliveryPostalCode: item.postalCode
        });
    }

    handleInputDepartureDate(value) {
        this.setState({
            departureDate: value,
            tariffs: null
        });
    }

    handleInputIsTemperatureCondition(value) {
        this.setState({
            isTemperatureCondition: value,
            lowTemperatureCondition: null,
            highTemperatureCondition: null
        });
    }

    handleInputIsDeclaredValue(value) {
        this.setState({
            isDeclaredValue: value,
            cargoDeclaredValue: null
        });
    }
    //#endregion

    selectFromWarehouse() {
        this.selectWarehouseModal.open("Доступные точки отправления", this.state.warehouses)
            .then((selection) => this.handleShipmentWarehouseSelect(selection));
    }

    clearFromWarehouse() {        
        this.setState({
            shipmentAddressName: null,
            shipmentWarehouse: null,
            shipmentWarehouseName: null,
            canEditFromAddress: true,
            fromAddress: null,
            fromCityName: null,
            fromRegionName: null,
            shipmentPostalCode: null,
            shipmentCity: null,
            shipmentCityName: null,
            shipmentFullCityName: null,
            shipmentCityAddressName: null,
            shipmentStreet: null,
            shipmentHouse: null,
            shipmentOffice: null,
            shipmentPhoneNumber: '',
            shipmentContactPersonName: null,            
            tariffs: null
            
        });
    }

    selectToWarehouse() {
        this.selectWarehouseModal.open("Доступные точки доставки", this.state.warehouses)
            .then((selection) => this.handleDeliveryWarehouseSelect(selection));
    }

    clearToWarehouse() {
        this.setState({
            deliveryAddressName: null,
            deliveryWarehouse: null,
            deliveryWarehouseName: null,
            canEditToAddress: true,
            toAddress: null,
            toCityName: null,
            toRegionName: null,
            deliveryPostalCode: null,
            deliveryCity: null,
            deliveryCityName: null,
            deliveryFullCityName: null,
            deliveryCityAddressName: null,
            deliveryStreet: null,
            deliveryHouse: null,
            deliveryOffice: null,
            deliveryPhoneNumber: '',
            deliveryContactPersonName: null,
            tariffs: null
        });
    }

    calcVolume(length, width, height) {
        this.setState({
            cargoLength: length,
            cargoWidth: width,
            cargoHeight: height,
            cargoVolume: (length * width * height * 0.000001).toFixed(3),
            tariffs: null

        });
    }

    validateNumber(number, name) {
        let errors = null;
        const regExp = /^[0-9]|\.|,:*$/;
        if (number !== "" && !regExp.test(number.toString())) {
            errors = errors ? errors : {};
            errors[name] = `${name} должно быть числом`;
        }
        return errors;
    }

    validateForm() {
        let errors = null;
        if (this.state.step === 0) {
            if (!this.state.shipmentAddressName) {
                errors = errors ? errors : {};
                errors["fromAddress"] = "Нужно указать город, адрес или индекс отправления.";
            } else if (!this.state.shipmentCity && !this.state.fromAddress) {
                errors = errors ? errors : {};
                errors["fromAddress"] =
                    "Нужно выбрать адрес отправления из предложенных вариантов выпадающего списка.";
            }

            if (!this.state.deliveryAddressName) {
                errors = errors ? errors : {};
                errors["toAddress"] = "Нужно указать город, адрес или индекс доставки.";
            } else if (!this.state.deliveryCity && !this.state.toAddress) {
                errors = errors ? errors : {};
                errors["toAddress"] =
                    "Нужно выбрать адрес доставки из предложенных вариантов выпадающего списка.";
            }
        }

        if (this.state.step === 2) { // здесь уже этап где нужно указывать точный адрес            
            if (!this.state.shipmentFullCityName) {
                errors = errors ? errors : {};
                errors["shipmentCity"] = "Нужно выбрать населенный пункт отправления из предложенных вариантов выпадающего списка.";
            }
            if (!this.state.shipmentHouse) {
                errors = errors ? errors : {};
                errors["shipmentHouse"] = "Нужно выбрать дом отправления из предложенных вариантов выпадающего списка.";
            }

            if (!this.state.shipmentPostalCode) {
                errors = errors ? errors : {};
                errors["shipmentPostalCode"] = "Нужно выбрать дом отправления из предложенных вариантов выпадающего списка.";
            }

            if (!this.state.shipmentContactPersonName) {
                errors = errors ? errors : {};
                errors["shipmentContactPerson"] = "Необходимо заполнить данные контактного лица";
            }


            if (this.state.shipmentPhoneNumber === null || this.state.shipmentPhoneNumber === undefined || this.state.shipmentPhoneNumber.length < 1 || findPhoneNumbersInText (this.state.shipmentPhoneNumber).length=== 0) {
                errors = errors ? errors : {};

                errors["shipmentPhone"] = "Необходимо заполнить номер телефона контактного лица";
            }

            if (!this.state.deliveryFullCityName) {
                errors = errors ? errors : {};
                errors["deliveryCity"] = "Нужно выбрать населенный пункт доставки из предложенных вариантов выпадающего списка.";
            }
            if (!this.state.deliveryHouse) {
                errors = errors ? errors : {};
                errors["deliveryHouse"] = "Нужно выбрать дом доставки из предложенных вариантов выпадающего списка.";
            }

            if (!this.state.deliveryPostalCode) {
                errors = errors ? errors : {};
                errors["deliveryPostalCode"] = "Нужно выбрать дом доставки из предложенных вариантов выпадающего списка.";
            }

            if (!this.state.deliveryContactPersonName) {
                errors = errors ? errors : {};
                errors["deliveryContactPerson"] = "Необходимо заполнить данные контактного лица";
            }

            
            if (this.state.deliveryPhoneNumber === null || this.state.deliveryPhoneNumber === undefined || this.state.deliveryPhoneNumber.length < 1 || findPhoneNumbersInText(this.state.deliveryPhoneNumber).length=== 0) {
                errors = errors ? errors : {};
                errors["deliveryPhone"] = "Необходимо заполнить номер телефона контактного лица";
            }
        }

        if (this.state.isDocument) {
            if (this.state.documentWeight === null || this.state.documentWeight === undefined || this.state.documentWeight.length < 1) {
                errors = errors ? errors : {};
                errors["documentWeight"] = " ";
            }
        } else {
            if (this.state.cargoVolume === null || this.state.cargoVolume === undefined || this.state.cargoVolume.length < 1) {
                errors = errors ? errors : {};
                errors["cargoVolume"] = " ";
            }

            if (this.state.cargoWeight === null || this.state.cargoWeight === undefined || this.state.cargoWeight.length < 1) {
                errors = errors ? errors : {};
                errors["cargoWeight"] = " ";
            }

            if (this.state.cargoPackages === null || this.state.cargoPackages === undefined || this.state.cargoPackages.length < 1) {
                errors = errors ? errors : {};
                errors["cargoPackages"] = " ";
            }

            if (!this.state.cargoDescription) {
                errors = errors ? errors : {};
                errors["cargoDescription"] = " ";
            }
        }

        return errors;
    }

    getCostModel() {
        return {
            onlyCompleteCosts: true,
            companyId: this.state.companyId,
            subCompanyId: this.state.subCompanyId,
            shipmentCity: this.state.shipmentCity,
            deliveryCity: this.state.deliveryCity,
            shipmentAddress: this.state.fromAddress,
            deliveryAddress: this.state.toAddress,
            parcelType: this.state.isDocument ? 1 : 2,
            weight: this.state.isDocument ? this.state.documentWeight : this.state.cargoWeight,
            volume: this.state.cargoVolume,
            length: this.state.cargoLength,
            height: this.state.cargoHeight,
            width: this.state.cargoWidth,
            packagesCount: this.state.cargoPackages,
            departureDate: this.state.departureDate,
            isReturnRequested: false, //todo: поправить когда докинем доп.услугу
            senderContactInfo: this.state.shipmentPhoneNumber,
            recipientContactInfo: this.state.deliveryPhoneNumber
        };
    }

    onFindTariffsByCities() {
        let errors = this.validateForm();
        if (errors) {
            this.setState({ errors });
        } else {
            this.updateBusyCount(1);
            if (this.state.tariffs != null) {
                this.updateBusyCount(-1);
                return;
            }

            this.setState(
                {
                    step: 0,
                    errors: {},
                    tariffs: []
                },
                () => {
                    this.loadTariffs(true)
                        .then(() => {
                            this.setState({
                                step: 1
                            });
                            this.updateBusyCount(-1);
                        })
                        .catch(err => this.updateBusyCount(-1));
                }
            );
        }
    }

    loadTariffs(syncState) {
        let result = [];
        let requestData = this.getCostModel();
        let promise = new Promise((resolve, reject) => {
            apiGet('parcels/cost/carriers/' + this.state.companyId)
                .then(response => {
                    if (response.entries) {
                        let loadingCount = 0;
                        response.entries.forEach((entry, ind, arr) => {
                            if (entry.hasIntegration) {
                                ++loadingCount;
                                apiPost('parcels/cost/calc/' + entry.id, requestData)
                                    .then(response => {
                                        --loadingCount;
                                        if (response.costs) {
                                            result = result.concat(response.costs);
                                            result.sort((a, b) => a.cost - b.cost);
                                            if (syncState) {
                                                this.setState({ tariffs: result });
                                            }
                                        }
                                        if (loadingCount === 0) {
                                            resolve(result);
                                        }
                                    })
                                    .catch(err => {
                                        --loadingCount;
                                        if (loadingCount === 0) {
                                            resolve(result);
                                        }
                                    });
                            }
                        });
                        if (loadingCount === 0) {
                            resolve(result);
                        }
                    }
                    else {
                        resolve(result);
                    }
                })
                .catch(err => reject(err));
        });
        return promise;
    }

    tryCreateParcel() {
        let errors = this.validateForm();
        if (errors) {
            this.setState({ errors });
        } else {

            this.updateBusyCount(1);
            this.setState(
                {
                    errors: {},
                    //tariffs: null
                },
                () => {
                    let selectedTariff = this.state.selectedTariff;

                    this.loadTariffs(false)
                        .then(newTariffs => {
                            this.updateBusyCount(-1);
                            if (!newTariffs || newTariffs.length == 0) {
                                this.infoModal.open("Выбранный тариф не найден", "После уточнения данных выбранный тариф более не доступен")
                                    .then(() => {
                                        this.setState({
                                            step: 1,
                                            tariffs: null
                                        });
                                        return;
                                    });
                                return;
                            } else if (this.state.originFromCityName !== this.state.shipmentCityName || this.state.originToCityName !== this.state.deliveryCityName) {
                                this.infoModal.open("Изменение исходных данных", "Изменились исходные данные для расчета тарифов, выберите тариф заново")
                                    .then(() => {
                                        this.setState({
                                            originFromCityName: this.state.shipmentCityName,
                                            shipmentAddressName: this.state.fromAddress && this.state.fromAddress.fullName,
                                            originToCityName: this.state.deliveryCityName,
                                            deliveryAddressName: this.state.toAddress && this.state.toAddress.fullName,
                                            step: 1,
                                            tariffs: newTariffs
                                        });
                                        return;
                                    });
                            } else {
                                //ищем выбранный тариф, но уже из списка по полным данным о грузе (по точному адресу)
                                let findOldTariff = newTariffs.find((entry, ind, array) => {
                                    return entry.cost === selectedTariff.cost
                                        && entry.carrierServiceName === selectedTariff.carrierServiceName;
                                });

                                let findSameTariff = newTariffs.find((entry, ind, array) => {
                                    return entry.carrierServiceName === selectedTariff.carrierServiceName;
                                });

                                // если тариф был найден с такой же ценой и названием, то создаем посылку
                                if (findOldTariff) {
                                    this.createParcel();
                                    return;
                                } else if (findSameTariff) { // если выбранный тариф нашли, но стоимость изменилась
                                    this.confirmModal.open("Стоимость тарифа изменилась",
                                        `После уточнения данных стоимость выбранного тарифа изменилась с ${numeral(selectedTariff.cost).format("0.00")} рублей на ${numeral(findSameTariff.cost).format("0.00")}`,
                                        "Выбрать другой тариф",
                                        "Заказать с данным тарифом")
                                        .then(() => {

                                            this.setState({
                                                step: 3,
                                                tariffs: newTariffs
                                            });
                                            return;
                                        })
                                        .catch((err) => {

                                            this.createParcel();
                                            return;
                                        });
                                } else {
                                    //если не нашли тариф и нужно предоставить право перевыбора
                                    //info modal
                                    this.infoModal.open("Выбранный тариф не найден", "После уточнения данных выбранный тариф более не доступен")
                                        .then(() => {
                                            this.setState({
                                                step: 3,
                                                tariffs: newTariffs
                                            });
                                            return;
                                        });
                                }
                            }
                        })
                        .catch(err => {
                            this.updateBusyCount(-1);
                            this.infoModal.open("Выбранный тариф не найден", "После уточнения данных выбранный тариф более не доступен")
                                .then(() => {
                                    this.setState({
                                        step: 1,
                                        tariffs: null
                                    });
                                    return;
                                });
                        });
                }
            );
        }
    }

    createParcel() {
        let parcelData = this.getParcelModel();
        this.updateBusyCount(1);

        apiPut('parcels/new', parcelData)
            .then(data => {
                let parcelId = data.parcelId;
                this.setState({
                    parcelId: parcelId,
                    step: 20
                });
                this.updateBusyCount(-1);
            })
            .catch(errors => {
                this.updateBusyCount(-1);
                this.setState({ errors: errors && errors.validationResult && errors.validationResult.messages });
            });
    }

    goToCreatedParcel() {
        this.props.history.push('/parcels/' + this.state.parcelId);
    }

    goToParcelList() {
        this.props.history.push('/parcels/list');
    }

    getParcelModel() {
        let currentUserId = getCurrentUserId(); 
        let fromAddressExt = null;
        let toAddressExt = null;
        if ((this.state.fromAddress && this.state.fromAddress.fullName.indexOf("кв/оф") === -1) && this.state.shipmentOffice) {
            fromAddressExt = this.state.fromAddress;
            fromAddressExt.fullName += ", кв/оф " + this.state.shipmentOffice;
        }
        if ((this.state.toAddress && this.state.toAddress.fullName.indexOf("кв/оф") === -1) && this.state.deliveryOffice) {
            toAddressExt = this.state.toAddress;
            toAddressExt.fullName += ", кв/оф " + this.state.deliveryOffice;
        }
        return {
            companyId: this.state.companyId,
            carrierId: this.state.selectedTariff && this.state.selectedTariff.carrierId,
            carrierServiceCode: this.state.selectedTariff && this.state.selectedTariff.carrierServiceCode,
            carrierServiceName: this.state.selectedTariff && this.state.selectedTariff.carrierServiceName,
            deliveryAddress: toAddressExt === null ? this.state.toAddress : toAddressExt,
            deliveryAddressComment: this.state.deliveryComment,
            deliveryAddressId: this.state.toAddressId,
            deliveryAddressName: this.state.toAddressName,
            deliveryCost: this.state.selectedTariff && this.state.selectedTariff.cost,
            deliveryWarehouseId: this.state.deliveryWarehouse && this.state.deliveryWarehouse.id,
            deliveryWarehouseName: this.state.deliveryWarehouse ? this.state.deliveryWarehouse.name : this.state.deliveryWarehouseName,
            departureDate: this.state.departureDate,
            packagesCount: this.state.cargoPackages,
            parcelType: this.state.isDocument ? 1 : 2,
            rawDeliveryCost: this.state.selectedTariff && this.state.selectedTariff.rawCost,
            recipientCompanyName: this.state.recipientCompanyName,
            recipientContactInfo: this.state.deliveryPhoneNumber,
            recipientInn: this.state.recipientInn,
            recipientName: this.state.deliveryContactPersonName,
            senderContactInfo: this.state.shipmentPhoneNumber,
            senderName: this.state.shipmentContactPersonName,

            shipmentAddress: fromAddressExt === null ? this.state.fromAddress : fromAddressExt,
            shipmentAddressComment: this.state.shipmentComment,
            shipmentAddressId: this.state.fromAddressId,
            shipmentAddressName: this.state.fromAddressName,
            shipmentWarehouseId: this.state.shipmentWarehouse && this.state.shipmentWarehouse.id,
            shipmentWarehouseName: this.state.shipmentWarehouse ? this.state.shipmentWarehouse.name : this.state.shipmentWarehouseName,
            tariffRate: this.state.tariffRate,
            volume: this.state.cargoVolume,
            weight: this.state.cargoWeight,
            length: this.state.cargoLength,
            width: this.state.cargoWidth,
            height: this.state.cargoHeight,
            cargoDescription: this.state.cargoDescription,
            carrierCostRequests: this.state.tariffs,
            vehicleTypeId: this.state.vehicleTypeId,
            initiatorId: currentUserId,
            isReadyToSend: true,
            shipmentCityId: this.state.shipmentCity && this.state.shipmentCity.id,
            deliveryCityId: this.state.deliveryCity && this.state.deliveryCity.id
        };
    }

    // вспомогательная функция для определения склонения слова "день" в зависимости от количества
    declOfNum(number, titles) {
        var cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }

    renderDays(number, currentLanguage) {
        if (currentLanguage === "ru") {
            return (<span>{number} {this.declOfNum(number, ['день', 'дня', 'дней'])}</span>);
        }
        else if (currentLanguage === "en") {
            return (<span>{number} days</span>);
        }
        return null;
    }

    renderCargoPackages(number, currentLanguage) {
        if (currentLanguage === "ru") {
            return (<span>{number} {this.declOfNum(number, ['место', 'места', 'мест'])}</span>);
        }
        else if (currentLanguage === "en") {
            return (<span>{number} places</span>);
        }
        return null;
    }

    renderCargoTab(isDisabled) {
        return (
            <div className="row">
                <table className="calc-cargo-table">
                    <tbody>
                        <tr>
                            <td className={"calc-cargo-td-field-table" + (this.state.errors.cargoLength ? " has-error" : "")}>
                                <label><Trans>Length</Trans></label>
                                <input type="number"
                                    className="form-control"
                                    onChange={event => {
                                        let errors = this.validateNumber(event.target.value, "cargoLength");
                                        if (errors) {
                                            this.setState({ errors });
                                        } else {
                                            this.calcVolume(event.target.value, this.state.cargoWidth, this.state.cargoHeight);
                                            this.state.errors.cargoLength = "";
                                            this.state.errors.cargoVolume = "";
                                        }
                                    }}
                                    value={this.state.cargoLength}
                                    disabled={isDisabled} />
                            </td>
                            <td><span className={"fa fa-times text-purple calc-multiply" + (this.state.errors.cargoWidth ? " has-error" : "")}></span></td>
                            <td className="calc-cargo-td-field-table">
                                <label><Trans>Width</Trans></label>
                                <input type="number"
                                    className="form-control"
                                    onChange={event => {
                                        let errors = this.validateNumber(event.target.value, "cargoWidth");
                                        if (errors) {
                                            this.setState({ errors });
                                        } else {
                                            this.calcVolume(this.state.cargoLength, event.target.value, this.state.cargoHeight);
                                            this.state.errors.cargoWidth = "";
                                            this.state.errors.cargoVolume = "";
                                        }
                                    }}
                                    value={this.state.cargoWidth}
                                    disabled={isDisabled}
                                />
                            </td>
                            <td><span className={"fa fa-times text-purple calc-multiply" + (this.state.errors.cargoHeight ? " has-error" : "")}></span></td>
                            <td className="calc-cargo-td-field-table">
                                <label><Trans>Height</Trans></label>
                                <input type="number"
                                    className="form-control"
                                    onChange={event => {
                                        let errors = this.validateNumber(event.target.value, "cargoHeight");
                                        if (errors) {
                                            this.setState({ errors });
                                        } else {
                                            this.calcVolume(this.state.cargoLength, this.state.cargoWidth, event.target.value);
                                            this.state.errors.cargoHeight = "";
                                            this.state.errors.cargoVolume = "";
                                        }
                                    }}
                                    value={this.state.cargoHeight}
                                    disabled={isDisabled}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td className={"calc-cargo-td-field-table" + (this.state.errors.cargoWeight ? " has-error" : "")}>
                                <label><Trans>Weight</Trans></label>
                                <input type="number"
                                    className="form-control"
                                    value={this.state.cargoWeight}
                                    onChange={
                                        event => {
                                            let errors = this.validateNumber(event.target.value, "cargoWeight");
                                            if (errors) {
                                                this.setState({ errors });
                                            } else {
                                                this.handleWeight(event.target.value);
                                                this.state.errors.cargoWeight = "";
                                            }
                                        }}
                                    disabled={isDisabled} />
                            </td>
                            <td></td>
                            <td className={"calc-cargo-td-field-table" + (this.state.errors.cargoVolume ? " has-error" : "")}>
                                <label><Trans>Volume</Trans></label>
                                <input type="number"
                                    className="form-control"
                                    value={this.state.cargoVolume}
                                    onChange={event => {
                                        let errors = this.validateNumber(event.target.value, "cargoVolume");
                                        if (errors) {
                                            this.setState({ errors });
                                        } else {
                                            this.handleVolume(event.target.value);
                                            this.state.errors.cargoVolume = "";
                                        }
                                    }}
                                    disabled={true}
                                />
                            </td>
                            <td></td>
                            <td className={"calc-cargo-td-field-table" + (this.state.errors.cargoPackages ? " has-error" : "")}>
                                <label><Trans>PackageCount</Trans></label>
                                <input type="number"
                                    className="form-control"
                                    onChange={event => {
                                        let errors = this.validateNumber(event.target.value, "cargoPackages");
                                        if (errors) {
                                            this.setState({ errors });
                                        } else {
                                            this.handlePackages(event.target.value);
                                            this.state.errors.cargoPackages = "";
                                        }
                                    }}
                                    value={this.state.cargoPackages}
                                    disabled={isDisabled}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="5" className={"calc-cargo-td-field-table" + (this.state.errors.cargoDescription ? " has-error" : "")}>
                                <label htmlFor="cargoDescription">Описание содержимого</label>
                                <TextInput id="cargoDescription"
                                    onChange={value => this.handleCargoDescription(value)}
                                    value={this.state.cargoDescription}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderTariff(collection, entry, ind, currentLanguage, isBusy) {
        let displayData = entry.displayData;
        let entryCost = displayData.cost ? numeral(displayData.cost).format("0.00") : '';
        let deliveryDays;
        if (displayData.maxDeliveryDay !== undefined && displayData.maxDeliveryDay !== "") {
            deliveryDays = <div><Trans>{displayData.minDeliveryDay}</Trans><span> - </span><Trans>{displayData.maxDeliveryDay}</Trans></div>;
        } else {
            deliveryDays = <div><Trans>{displayData.minDeliveryDay}</Trans></div>;
        }
        return (
            <tr key={'cost-entry-' + ind}>
                <td>{displayData.carrierName}<span className="calc-week-day">{displayData.carrierServiceName}</span></td>
                <td>{displayData.departureDate}<span className="calc-week-day"><Trans>{displayData.departureDay}</Trans></span></td>
                <td>{this.renderDays(displayData.maxDays, currentLanguage)}</td>
                <td>{displayData.deliveryTime}<span className="calc-week-day">{deliveryDays}</span></td>
                <td>{entryCost} ₽</td>
                <td style={{ verticalAlign: 'middle' }}>
                    <button className="calc-btn" disabled={isBusy} onClick={() => this.handleSelectTariff(collection, ind, displayData.maxDays)}>
                        <Trans>Select</Trans>
                    </button>
                </td>
            </tr>
        );
    }

    renderTableTariffs(isBusy, collection, minDisplayStep, maxDisplayStep) {
        if (this.state.step < minDisplayStep || this.state.step > maxDisplayStep)
            return null;

        if (collection === undefined || collection === null)
            return <div className="row" style={{ marginTop: 10, marginBottom: 10 }}>
                <div className="col-md-12">
                    <button className="calc-btn calc-btn-active" disabled={isBusy} onClick={() => this.onFindTariffsByCities()}>
                        <Trans>GetShippingRates</Trans>
                    </button>
                </div>
            </div>;

        if (!isBusy && collection.length === 0) {
            return (
                <div className="text-center">
                    <span className="calc-h2"><Trans>NotFoundResults</Trans></span>
                </div>
            );
        }
        
        return (
            <div className="row">
                <div className="col-md-9 col-sm-12">
                    <div className="box calc-box" style={{ minHeight: 500 }}>
                        <div className="calc-box-header">
                            <span style={{ marginLeft: 7 }}><Trans>Tariffs</Trans></span>
                            {isBusy
                                ? <img src="/img/spinner.gif" alt="loading" width="40" height="40" style={{ marginTop: "-16px", marginBottom: "-10px"}} />
                                : null
                            }
                        </div>
                        <div className="box-body">
                            <table className="table tariff-table">
                                <thead>
                                    <tr>
                                        <th><b>Перевозчик</b></th>
                                        <th><b><Trans>PickupDate</Trans></b></th>
                                        <th><b><Trans>DeliveryDays</Trans></b></th>
                                        <th><b><Trans>DeliveryDate</Trans></b></th>
                                        <th><b><Trans>Tariff</Trans></b> <Trans>VAT</Trans></th>
                                        <th style={{ width: 115 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {collection ? collection.map((entry, index) => this.renderTariff(collection, entry, index, this.state.currentLanguage, isBusy)) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <div className="box calc-box" style={{ height: 230 }}>
                        <div className="calc-box-header">
                            <span><Trans>Services</Trans></span>
                        </div>
                        <div className="box-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="radio">
                                        <label>
                                            <input
                                                type="radio"
                                                value="doortodoor"
                                                defaultChecked={true}
                                                disabled={isBusy}
                                            />
                                            <Trans>DoorToDoorDelivery</Trans>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCountryOption(option) {
        return (
            <div className="Select-value">
                <div className={"country-icon-" + option.label.toLowerCase()}></div>
                <span className="Select-value-label" role="option" aria-selected="true" id="react-select-2--value-item">{option.label}</span>
            </div>
        );
    }

    renderParcelSettings(isBusy) {
        let isDisabled = isBusy || this.state.step >= 2;

        return (
            <div className="col-lg-4 col-sm-12">
                <div className="box calc-box" style={{ height: 400 }}>
                    <div className="calc-box-header">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <div className="pull-left">
                                    <div className="toggle-group" style={(isDisabled ? { pointerEvents: "none", opacity: "0.4", marginTop: 25 } : { marginTop: 25 })}>
                                        <span className={"toggle-button " + (this.state.isDocument ? 'toggle-active' : '')}
                                            onClick={() => this.handleParcelTypeSwitch(true)}>
                                            <Trans>Documents</Trans>
                                        </span>
                                        <span className={"toggle-button " + (!this.state.isDocument ? 'toggle-active' : '')} onClick={() => this.handleParcelTypeSwitch(false)}><Trans>Cargo</Trans></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="pull-right cargo-header-info">
                                    <div className="form-group">
                                        <label><Trans>PickupDate</Trans></label>
                                        <br />
                                        <DateTimeInput id="inputDepartureDate"
                                            enableTime={false}
                                            openDirection="down"
                                            value={this.state.departureDate}
                                            onChange={value => this.handleInputDepartureDate(value)}
                                            isStartIcon={true}
                                            disabled={isDisabled}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-body">
                        {this.state.isDocument &&
                            <div className="row">
                                <div className={"col-xs-12" + (this.state.errors.documentWeight ? " has-error" : "")}>
                                    <div className="calc-form-group">
                                        <label><Trans>Weight</Trans></label>
                                        <input type="text"
                                            className="form-control"
                                            value={this.state.documentWeight}
                                            onChange={event => {
                                                let errors = this.validateNumber(event.target.value, "documentWeight");
                                                if (errors) {
                                                    this.setState({ errors });
                                                } else {
                                                    this.handleDocumentWeight(event.target.value);
                                                    this.state.errors.documentWeight = "";
                                                }
                                            }}
                                            disabled={isDisabled}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {!this.state.isDocument &&
                            this.renderCargoTab(isDisabled)
                        }
                    </div>
                </div>
            </div>);
    }

    renderFromWarehouse(isBusy) {
        if (this.state.shipmentWarehouseName) {
            return (
                <div className="row">
                    <div className="col-xs-offset-2 col-xs-10">
                        <p className="text-muted">
                            {this.state.shipmentWarehouseName}
                            <a className="text-danger"
                                role="button"
                                style={{ verticalAlign: "middle", marginLeft: "4px" }}
                                disabled={isBusy}
                                onClick={() => this.clearFromWarehouse()}
                            >
                                <i className="glyphicon glyphicon-remove"></i>
                            </a>
                        </p>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderToWarehouse(isBusy) {
        if (this.state.deliveryWarehouseName) {
            return (
                <div className="row">
                    <div className="col-xs-offset-2 col-xs-10">
                        <p className="text-muted">
                            {this.state.deliveryWarehouseName}
                            <a className="text-danger"
                                role="button"
                                style={{ verticalAlign: "middle", marginLeft: "4px" }}
                                disabled={isBusy}
                                onClick={() => this.clearToWarehouse()}
                            >
                                <i className="glyphicon glyphicon-remove"></i>
                            </a>
                        </p>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderFromCity(isBusy) {
        let isDisabled = isBusy || this.state.step >= 2;
        return (<div className="box calc-box" style={{ height: 190 }}>
            <div className="calc-box-header">
                <span><Trans>PickupFrom</Trans></span>
            </div>
            <div className="box-body">
                <div className="select-warehouse-button">
                    <button className="calc-btn btn-block"
                        onClick={() => this.selectFromWarehouse()}
                        disabled={isBusy}
                    >
                        <i class="fa fa-book"></i>                        
                    </button>
                </div>
                {this.renderFromWarehouse(isBusy)}
                <div className="row">
                    <div className={"col-xs-2"}>
                        <div className="form-group">
                            <SelectInput id="selectFromCountry"
                                options={this.state.countries}
                                optionRenderer={this.renderCountryOption}
                                valueRenderer={this.renderCountryOption}
                                clearable={false}
                                value={this.state.fromAddressCountry ? this.state.fromAddressCountry.Id : null}
                                onChange={e => {
                                    this.handleChangeFromCountry(e);
                                }}
                                disabled={isDisabled} />
                        </div>
                    </div>
                    <div className={"col-xs-10" + (this.state.errors.fromAddress ? " has-error" : "")}>
                        <AutoCompleteTextInput id="inputFromAddress"
                            className="calc-input"
                            title={this.state.errors.fromAddress}
                            value={this.state.shipmentAddressName}
                            getItemKey={item => item.id}
                            getItemValue={item => item.fullName}
                            onChange={value => this.handleFromAddressChange(value)}
                            onItemSelect={item => this.handleFromAddressSelect(item)}
                            loadItems={(text, sessionKey) => this.loadCitySuggestions(text, sessionKey, this.state.fromAddressCountry.Code, true)}
                            loadDefaultByClick={true}
                            disabled={isDisabled || this.state.fromWarehouse}
                            isItemSelected={this.state.shipmentCity !== null}
                            i18nPlaceholder={'StartEnterAddress'}
                            groupIcon={<i className="fa fa-search"></i>} />
                    </div>
                </div>
            </div>
        </div>);
    }

    renderToCity(isBusy) {
        let isDisabled = isBusy || this.state.step >= 2;
        return (<div className="box calc-box" style={{ height: 190 }}>
            <div className="calc-box-header">
                <span><Trans>DeliverTo</Trans></span>
            </div>
            <div className="box-body">
                <div className="select-warehouse-button">
                    <button className="calc-btn btn-block"
                        onClick={() => this.selectToWarehouse()}
                        disabled={isBusy}
                    >
                        <i class="fa fa-book"></i>                         
                    </button>
                </div>
                {this.renderToWarehouse(isBusy)}
                <div className="row">
                    <div className={"col-xs-2"}>
                        <div className="form-group">
                            <SelectInput id="selectToCountry"
                                options={this.state.countries}
                                optionRenderer={this.renderCountryOption}
                                valueRenderer={this.renderCountryOption}
                                clearable={false}
                                value={this.state.toAddressCountry ? this.state.toAddressCountry.Id : null}
                                onChange={e => {
                                    this.handleChangeToCountry(e);
                                }}
                                disabled={isDisabled}
                            />
                        </div>
                    </div>
                    <div className={"col-xs-10" + (this.state.errors.toAddress ? " has-error" : "")}>
                        <AutoCompleteTextInput id="inputToAddress"
                            className="calc-input"
                            title={this.state.errors.toAddress}
                            value={this.state.deliveryAddressName}
                            getItemKey={item => item.id}
                            getItemValue={item => item.fullName}
                            onChange={value => this.handleToAddressChange(value)}
                            onItemSelect={item => this.handleToAddressSelect(item)}
                            loadItems={(text, sessionKey) => this.loadCitySuggestions(text, sessionKey, this.state.toAddressCountry.Code, false)}
                            loadDefaultByClick={true}
                            disabled={isDisabled || this.state.toWarehouse}
                            isItemSelected={this.state.deliveryCity !== null}
                            i18nPlaceholder={'StartEnterAddress'}
                            groupIcon={<i className="fa fa-search"></i>}
                        />
                    </div>
                </div>
            </div>
        </div>);
    }

    renderParcelSettingsAndCitiesContainer(isBusy) {
        if (this.state.step === 20)
            return null;
        return (
            <div className="row">
                {this.renderParcelSettings(isBusy)}
                <div className="col-lg-8 col-xs-12">
                    {this.renderFromCity(isBusy)}
                    {this.renderToCity(isBusy)}
                </div>
            </div>
        );
    }

    renderFromAddress(isBusy) {
        if (this.state.step !== 2)
            return null;

        let isEditableAddress = this.state.canEditFromAddress;
        return (
            <div className="row">
                <div className="col-md-9 col-sm-12">
                    <div className="box calc-box" style={{ minHeight: 310, paddingBottom: 20 }}>
                        <div className="calc-box-header">
                            <span style={{ marginLeft: 7 }}><Trans>Sender</Trans></span>
                        </div>
                        <div className="box-body">
                            <div className="calc-form-group" style={{ marginLeft: 7 }}>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className={"form-group"}>
                                            <label htmlFor="inputShipmentWarehouse"><Trans>WarehouseFrom</Trans></label>
                                            <a tabIndex="0" role="button" title="Введите наименование, по которому Вам в дальнейшем будет легко найти необходимую точку отправления или доставки при заведении посылки.">
                                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                                            </a>
                                            <AutoCompleteTextInput id="inputShipmentWarehouse"
                                                title={this.state.errors.shipmentWarehouse ? this.state.errors.shipmentWarehouse : this.state.errors.shipmentWarehouseName}
                                                value={this.state.shipmentWarehouseName}
                                                getItemKey={item => item.id}
                                                getItemValue={item => item.name}
                                                onChange={value => this.handleShipmentWarehouseChange(value)}
                                                onItemSelect={item => this.handleShipmentWarehouseSelect(item)}
                                                items={this.state.warehouses}
                                                shouldItemRender={(item, value) => (!value || value.length === 0 || item.name.toLowerCase().indexOf(value.toLowerCase()) >= 0)}
                                                renderItemValue={item => item.isUserPoint ? item.name : <b>{item.name}</b>}
                                                isItemSelected={this.state.shipmentWarehouse !== null}
                                                i18nPlaceholder={'StartEnterWarehouse'}
                                                disabled={isBusy}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className={"col-xs-2"}>
                                        <div className="form-group">
                                            <label htmlFor="selectShipmentCountry"><Trans>Country</Trans><span className="text-red">*</span></label>
                                            <SelectInput id="selectShipmentCountry"
                                                options={this.state.countries}
                                                optionRenderer={this.renderCountryOption}
                                                valueRenderer={this.renderCountryOption}
                                                clearable={false}
                                                value={this.state.shipmentAddressCountry ? this.state.shipmentAddressCountry.Id : null}
                                                onChange={e => {
                                                    this.handleChangeShipmentCountry(e);
                                                }}
                                                disabled={isBusy || !isEditableAddress}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xs-3">
                                        <div className={"form-group" + (this.state.errors.shipmentCity ? " has-error" : "")}>
                                            <label htmlFor="inputShipmentCity"><Trans>City</Trans><span className="text-red">*</span></label>
                                            <AutoCompleteTextInput id="inputShipmentCity"
                                                title={this.state.errors.shipmentCity}
                                                value={this.state.shipmentFullCityName}
                                                getItemKey={item => item.id}
                                                getItemValue={item => item.fullCityAddress}
                                                onChange={value => this.handleShipmentAddressChange(value)}
                                                onItemSelect={item => this.handleShipmentAddressSelect(item)}
                                                loadItems={(text, sessionKey) => this.loadFullCityAddressSuggestions(text, sessionKey,
                                                    this.state.shipmentAddressCountry.Code)}
                                                disabled={isBusy || !isEditableAddress}
                                                isItemSelected={this.state.shipmentFullCityName !== null}
                                            />
                                        </div>
                                    </div>
                                    <div className={"form-group col-xs-3"}>
                                        <label htmlFor="inputShipmentStreet"><Trans>Street</Trans></label>
                                        <AutoCompleteTextInput id="inputShipmentStreet"
                                            title={this.state.errors.shipmentStreet}
                                            value={this.state.shipmentStreet}
                                            getItemKey={item => item.id}
                                            getItemValue={item => item.street}
                                            onChange={value => this.handleShipmentStreetChange(value)}
                                            onItemSelect={item => this.handleShipmentStreetSelect(item)}
                                            loadItems={(text, sessionKey) => this.loadStreetAddressSuggestions(text, sessionKey,
                                                this.state.shipmentAddressCountry.Code, this.state.shipmentFullCityName)}
                                            disabled={isBusy || !isEditableAddress}
                                            isItemSelected={this.state.shipmentStreet !== null}
                                        />
                                    </div>
                                    <div className="col-xs-2">
                                        <div className={"form-group" + (this.state.errors.shipmentHouse ? " has-error" : "")}>
                                            <label htmlFor="inputShipmentHouse"><Trans>House</Trans><span className="text-red">*</span></label>
                                            <AutoCompleteTextInput id="inputShipmentHouse" startFindNumber={1}
                                                title={this.state.errors.shipmentHouse}
                                                value={this.state.shipmentHouse}
                                                getItemKey={item => item.id}
                                                getItemValue={item => item.houseAddress}
                                                onChange={value => this.handleShipmentHouseChange(value)}
                                                onItemSelect={item => this.handleShipmentHouseSelect(item)}
                                                loadItems={(text, sessionKey) => this.loadHouseAddressSuggestions(text, sessionKey,
                                                    this.state.shipmentAddressCountry.Code, this.state.shipmentFullCityName, this.state.shipmentStreet)}
                                                disabled={isBusy || !isEditableAddress}
                                                isItemSelected={this.state.shipmentHouse !== null}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-xs-1"}>
                                        <label htmlFor="inputShipmentOffice"><Trans>Office</Trans></label>
                                        <TextInput id="inputShipmentOffice"
                                            value={this.state.shipmentOffice}
                                            onChange={value => this.setState({ shipmentOffice: value })}
                                            disabled={isBusy || !isEditableAddress}
                                        />
                                    </div>
                                    <div className={"form-group col-xs-1" + (this.state.errors.shipmentPostalCode ? " has-error" : "")}>
                                        <label htmlFor="inputShipmentPostalCode"><Trans>PostalCode</Trans><span className="text-red">*</span></label>
                                        <TextInput id="inputShipmentPostalCode"
                                            title={this.state.errors.shipmentPostalCode}
                                            value={this.state.shipmentPostalCode}
                                            disabled={true}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className={"form-group"}>
                                            <label htmlFor="inputShipmentComment"><Trans>Comment</Trans></label>
                                            <TextInput id="inputShipmentComment"
                                                title={this.state.errors.shipmentComment}
                                                value={this.state.shipmentComment}
                                                onChange={value => this.setState({ shipmentComment: value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-7">
                                        <div className="row">
                                            <div className={"form-group col-xs-8" + (this.state.errors.shipmentContactPerson ? " has-error" : "")}>
                                                <label htmlFor="inputShipmentContactPerson"><Trans>ContactPerson</Trans><span className="text-red">*</span></label>
                                                <TextInput id="inputShipmentContactPerson"
                                                    value={this.state.shipmentContactPersonName}
                                                    onChange={value => this.handleShipmentContactPersonChange(value)}
                                                    disabled={isBusy}
                                                    
                                                />
                                            </div>
                                            <div className={"form-group col-xs-4" + (this.state.errors.shipmentPhone ? " has-error" : "")}>
                                                <label htmlFor="inputShipmentPhone"><Trans>Phone</Trans><span className="text-red">*</span></label>
                                                <PhoneInput id="inputShipmentPhone"
                                                    localization={ru}
                                                    country={this.state.defaultCountry}
                                                    enableSearch={true}
                                                    placeholder={''}
                                                    disableSearchIcon={true}
                                                    enableAreaCodes={true}
                                                    preferredCountries={['ru']}
                                                    value={this.state.shipmentPhoneNumber}
                                                    disabled={isBusy}
                                                    onChange={value => this.handleShipmentPhoneChange(value)}
                                                    inputProps={{ required: true }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-xs-12">
                    {this.renderSummaryOrder()}
                </div>
            </div>
        );
    }

    renderToAddress(isBusy) {
        if (this.state.step !== 2)
            return null;

        let isEditableAddress = this.state.canEditToAddress;
        return (
            <div className="row">
                <div className="col-md-9 col-sm-12">
                    <div className="box calc-box" style={{ minHeight: 310, paddingBottom: 20 }}>
                        <div className="calc-box-header">
                            <span style={{ marginLeft: 7 }}><Trans>Recipient</Trans></span>
                        </div>
                        <div className="box-body">
                            <div className="calc-form-group" style={{ marginLeft: 7 }}>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className={"form-group"}>
                                            <label htmlFor="inputDeliveryWarehouse"><Trans>WarehouseTo</Trans></label>
                                            <a tabIndex="0" role="button" title="Введите наименование, по которому Вам в дальнейшем будет легко найти необходимую точку отправления или доставки при заведении посылки.">
                                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                                            </a>
                                            <AutoCompleteTextInput id="inputDeliveryWarehouse"
                                                title={this.state.errors.deliveryWarehouse ? this.state.errors.deliveryWarehouse : this.state.errors.deliveryWarehouseName}
                                                value={this.state.deliveryWarehouseName}
                                                getItemKey={item => item.id}
                                                getItemValue={item => item.name}
                                                onChange={value => this.handleDeliveryWarehouseChange(value)}
                                                onItemSelect={item => this.handleDeliveryWarehouseSelect(item)}
                                                items={this.state.warehouses}
                                                shouldItemRender={(item, value) => (!value || value.length === 0 || item.name.toLowerCase().indexOf(value.toLowerCase()) >= 0)}
                                                renderItemValue={item => item.isUserPoint ? item.name : <b>{item.name}</b>}
                                                isItemSelected={this.state.deliveryWarehouse !== null}
                                                i18nPlaceholder={'StartEnterWarehouse'}
                                                disabled={isBusy}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className={"col-xs-2"}>
                                        <div className="form-group">
                                            <label htmlFor="selectDeliveryCountry"><Trans>Country</Trans><span className="text-red">*</span></label>
                                            <SelectInput id="selectDeliveryCountry"
                                                options={this.state.countries}
                                                optionRenderer={this.renderCountryOption}
                                                valueRenderer={this.renderCountryOption}
                                                clearable={false}
                                                value={this.state.deliveryAddressCountry ? this.state.deliveryAddressCountry.Id : null}
                                                onChange={e => {
                                                    this.handleChangeDeliveryCountry(e);
                                                }}
                                                disabled={isBusy || !isEditableAddress}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xs-3">
                                        <div className={"form-group" + (this.state.errors.deliveryCity ? " has-error" : "")}>
                                            <label htmlFor="inputDeliveryCity"><Trans>City</Trans><span className="text-red">*</span></label>
                                            <AutoCompleteTextInput id="inputDeliveryCity"
                                                title={this.state.errors.deliveryCity}
                                                value={this.state.deliveryFullCityName}
                                                getItemKey={item => item.id}
                                                getItemValue={item => item.fullCityAddress}
                                                onChange={value => this.handleDeliveryAddressChange(value)}
                                                onItemSelect={item => this.handleDeliveryAddressSelect(item)}
                                                loadItems={(text, sessionKey) => this.loadFullCityAddressSuggestions(text, sessionKey,
                                                    this.state.deliveryAddressCountry.Code)}
                                                disabled={isBusy || !isEditableAddress}
                                                isItemSelected={this.state.deliveryFullCityName !== null}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xs-3">
                                        <div className={"form-group"}>
                                            <label htmlFor="inputDeliveryStreet"><Trans>Street</Trans></label>
                                            <AutoCompleteTextInput id="inputDeliveryStreet"
                                                title={this.state.errors.deliveryStreet}
                                                value={this.state.deliveryStreet}
                                                getItemKey={item => item.id}
                                                getItemValue={item => item.street}
                                                onChange={value => this.handleDeliveryStreetChange(value)}
                                                onItemSelect={item => this.handleDeliveryStreetSelect(item)}
                                                loadItems={(text, sessionKey) => this.loadStreetAddressSuggestions(text, sessionKey,
                                                    this.state.deliveryAddressCountry.Code, this.state.deliveryFullCityName)}
                                                disabled={isBusy || !isEditableAddress}
                                                isItemSelected={this.state.deliveryStreet !== null}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xs-2">
                                        <div className={"form-group" + (this.state.errors.deliveryHouse ? " has-error" : "")}>
                                            <label htmlFor="inputDeliveryHouse"><Trans>House</Trans><span className="text-red">*</span></label>
                                            <AutoCompleteTextInput id="inputDeliveryHouse" startFindNumber={1}
                                                title={this.state.errors.deliveryHouse}
                                                value={this.state.deliveryHouse}
                                                getItemKey={item => item.id}
                                                getItemValue={item => item.houseAddress}
                                                onChange={value => this.handleDeliveryHouseChange(value)}
                                                onItemSelect={item => this.handleDeliveryHouseSelect(item)}
                                                loadItems={(text, sessionKey) => this.loadHouseAddressSuggestions(text, sessionKey,
                                                    this.state.deliveryAddressCountry.Code, this.state.deliveryFullCityName, this.state.deliveryStreet)}
                                                disabled={isBusy || !isEditableAddress}
                                                isItemSelected={this.state.deliveryHouse !== null}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-xs-1"}>
                                        <label htmlFor="inputDeliveryOffice"><Trans>Office</Trans></label>
                                        <TextInput id="inputDeliveryOffice"
                                            value={this.state.deliveryOffice}
                                            onChange={value => this.setState({ deliveryOffice: value })}
                                            disabled={isBusy || !isEditableAddress}
                                        />
                                    </div>
                                    <div className={"form-group col-xs-1" + (this.state.errors.deliveryPostalCode ? " has-error" : "")}>
                                        <label htmlFor="inputDeliveryPostalCode"><Trans>PostalCode</Trans><span className="text-red">*</span></label>
                                        <TextInput id="inputDeliveryPostalCode"
                                            title={this.state.errors.deliveryPostalCode}
                                            value={this.state.deliveryPostalCode}
                                            disabled={true}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className={"form-group"}>
                                            <label htmlFor="inputDeliveryComment"><Trans>Comment</Trans></label>
                                            <TextInput id="inputDeliveryComment"
                                                value={this.state.deliveryComment}
                                                onChange={value => this.setState({ deliveryComment: value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-7">
                                        <div className="row">
                                            <div className={"form-group col-xs-8" + (this.state.errors.deliveryContactPerson ? " has-error" : "")}>
                                                <label htmlFor="inputDeliveryContactPerson"><Trans>ContactPerson</Trans><span className="text-red">*</span></label>
                                                <TextInput id="inputDeliveryContactPerson"
                                                    title={this.state.errors.deliveryContactPerson}
                                                    value={this.state.deliveryContactPersonName}
                                                    disabled={isBusy}
                                                    onChange={value => this.handleDeliveryContactPersonChange(value)}
                                                />
                                            </div>
                                            <div className={"form-group col-xs-4" + (this.state.errors.deliveryPhone ? " has-error" : "")}>
                                                <label htmlFor="inputDeliveryPhone"><Trans>Phone</Trans><span className="text-red">*</span></label>
                                                <PhoneInput id="inputDeliveryPhone"
                                                    localization={ru}
                                                    country={'ru'}
                                                    enableSearch={true}
                                                    placeholder={''}
                                                    disableSearchIcon={true}
                                                    enableAreaCodes={true}
                                                    preferredCountries={['ru']}
                                                    value={this.state.deliveryPhoneNumber}
                                                    disabled={isBusy}
                                                    onChange={value => this.handleDeliveryPhoneChange(value)}
                                                    inputProps={{ required: true }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCargoHeaderInfo() {
        if (this.state.isDocument) {
            return (
                <div className="pull-right cargo-header-info" style={{ marginLeft: 7 }}>
                    <span>Вес <b>{this.state.documentWeight} кг</b></span>
                </div>
            );
        } else {
            return (
                <div className="pull-right cargo-header-info" style={{ marginLeft: 7 }}>
                    <span>Габариты (Д х Ш х В) <b>{this.state.cargoLength} х {this.state.cargoWidth} х {this.state.cargoHeight}</b>, {this.renderCargoPackages(this.state.cargoPackages, this.state.currentLanguage)}</span>
                    <span>Вес <b>{this.state.cargoWeight} кг</b></span>
                    <span>Объем <b>{this.state.cargoVolume} м3</b></span>
                </div>);
        }
    }

    /*renderCargo(isBusy) {
        if (this.state.step !== 2)
            return null;
    
        return (
            <div className="row">
                <div className="col-lg-8 col-lg-offset-1 col-md-9 col-sm-12">
                    <div className="box calc-box" style={{ minHeight: 310, paddingBottom: 20 }}>
                        <div className="calc-box-header">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="pull-left">
                                        <span className="calc-box-header-text" style={{ marginLeft: 7 }}><Trans>Cargo</Trans></span>
                                    </div>
                                    {this.renderCargoHeaderInfo()}
                                </div>
                            </div>
                        </div>
                        <div className="box-body">
                            <div className="calc-form-group" style={{ marginLeft: 7 }}>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className={"form-group"}>
                                            <label htmlFor="cargoDescription">Описание содержимого</label>
                                            <TextInput id="cargoDescription"
                                                onChange={value => this.setState({ cargoDescription: value })}
                                                value={this.state.cargoDescription}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xs-12">
                                        <div className="form-inline">
                                            <label className="font-weight-normal">
                                                <CheckBoxInput id="inputTemperatureCondition"
                                                    title={this.state.errors.isTemperatureCondition}
                                                    checked={this.state.isTemperatureCondition}
                                                    onChange={value => this.handleInputIsTemperatureCondition(value)}
                                                    disabled={isBusy}
                                                /> Терморежим, °C
                                            </label>
                                            <TextInput id="inputLowTemperatureCondition" style={{ width: 75, marginLeft: 20 }}
                                                type="number"
                                                value={this.state.lowTemperatureCondition}
                                                placeholder="от °C"
                                                disabled={isBusy || !this.state.isTemperatureCondition}
                                                onChange={value => this.setState({ lowTemperatureCondition: value })}
                                            />
                                            <span style={{ marginLeft: 10 }}>—</span>
                                            <TextInput id="inputHighTemperatureCondition" style={{ width: 75, marginLeft: 10 }}
                                                type="number"
                                                value={this.state.highTemperatureCondition}
                                                placeholder="до °C"
                                                disabled={isBusy || !this.state.isTemperatureCondition}
                                                onChange={value => this.setState({ highTemperatureCondition: value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: 15 }}>
                                    <div className="col-xs-12">
                                        <div className="form-inline">
                                            <label className="font-weight-normal">
                                                <CheckBoxInput id="inputIsDeclaredValue"
                                                    title={this.state.errors.isDeclaredValue}
                                                    checked={this.state.isDeclaredValue}
                                                    onChange={value => this.handleInputIsDeclaredValue(value)}
                                                    disabled={isBusy}
                                                /> Объявленная стоимость, ₽
                                            </label>
                                            <TextInput id="inputCargoDeclaredValue" style={{ width: 100, marginLeft: 20 }}
                                                type="number"
                                                value={this.state.cargoDeclaredValue}
                                                placeholder="₽"
                                                disabled={isBusy || !this.state.isDeclaredValue}
                                                onChange={value => this.setState({ cargoDeclaredValue: value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="form-inline">
                                            <div className="form-group">
                                                <label><Trans>PickupDate</Trans></label>
                                                <br />
                                                <DateTimeInput id="inputDepartureDate"
                                                    enableTime={false}
                                                    openDirection="up"
                                                    value={this.state.departureDate}
                                                    onChange={value => this.handleInputDepartureDate(value)}
                                                    isStartIcon={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }}*/

    renderCreateParcelButton() {
        if (this.state.step !== 2)
            return null;

        return <div className="row" style={{ marginTop: 10, marginBottom: 10 }}>
            <div className="col-lg-10 col-lg-offset-1 col-md-12">
                <button className="calc-btn calc-btn-active" onClick={() => this.createParcel()}>
                    <Trans>OrderDelivery</Trans>
                </button>
            </div>
        </div>;
    }

    renderSummaryOrder() {
        return (
            <div>
                <div className="box calc-box">
                    <div className="calc-box-header">
                        <span style={{ marginLeft: 5 }}><Trans>Delivery</Trans></span>
                    </div>
                    <div style={{ margin: 20 }}>
                        <p>{this.state.selectedTariff.carrierName}</p>
                        <p>Основная стоимость <b>{numeral(this.state.selectedTariff.cost).format("0.00")}</b></p>
                    </div>
                    <div className="calc-box-bottom">
                        <p style={{ marginTop: 10 }}>ИТОГО <b>{numeral(this.state.selectedTariff.cost).format("0.00")} ₽</b></p>
                    </div>
                </div>

                <div className="form-group offer-checkbox pull-right">
                    Нажимая кнопку «Заказать отправку», я соглашаюсь с условиями публичной оферты, работы курьерских служб и даю согласие на обработку персональных данных
                </div>

                <div>
                    <button className="calc-btn btn-block" onClick={() => this.tryCreateParcel()}>
                        <Trans>OrderDelivery</Trans>
                    </button>
                </div>
                <div style={{ marginTop: 10 }}>
                    <button className="calc-btn btn-block" style={{ fontWeight: 'normal' }} onClick={() => this.setState({ step: 1, selectedTariff: null }, () => this.onFindTariffsByCities())}>
                        <Trans>TakeAnotherTariff</Trans>
                    </button>
                </div>
            </div>
        );
    }

    renderSuccessOrder() {
        if (this.state.step !== 20)
            return null;
        return (
            <div style={{ marginLeft: 100, marginTop: 20 }}>
                <div className="row">
                    <div className="col-xs-12">
                        <p className="calc-h1">Ваш заказ принят!</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <button className="calc-btn"
                            onClick={() => this.goToCreatedParcel()}>Открыть карточку заказа</button>
                        <button style={{ marginLeft: 30 }}
                            className="calc-btn"
                            onClick={() => this.goToParcelList()}>Перейти к моим посылкам</button>
                    </div>
                </div>
            </div>
        );
    }

    renderBusyOverlay(isBusy) {
        return isBusy && this.state.step > 1
            ? <div className="loading">
                <img src="/img/spinner.gif" alt="loading" width="100" height="100" />
            </div>
            : null;
    }

    render() {
        let isBusy = this.state.busyCount > 0;
        return (
            <div>
                <section className="content" style={{ marginLeft: 30, marginRight: 30 }}>
                    {this.renderBusyOverlay(isBusy)}
                    {this.renderParcelSettingsAndCitiesContainer(isBusy)}
                    {this.renderTableTariffs(isBusy, this.state.tariffs, 0, 1)}
                    {this.renderFromAddress(isBusy)}
                    {this.renderToAddress(isBusy)}
                    {this.renderTableTariffs(isBusy, this.state.tariffs, 3, 3)}
                    {this.renderSuccessOrder()}
                    <ConfirmModal ref={modal => this.confirmModal = modal} />
                    <InfoModal ref={modal => this.infoModal = modal} />
                    <SelectWarehouseModal ref={modal => this.selectWarehouseModal = modal} />
                    <FillRecipientCompanyModal ref={modal => this.fillRecipientModal = modal} />
                </section>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v2/createParcelForm.jsx